import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Container, Row, Col, Modal, Form, FloatingLabel } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBeer, faPeopleGroup, faFootball } from '@fortawesome/free-solid-svg-icons';

import './AddVenue.scoped.scss';

import { db } from '../../../firebase/config';
import { collection, addDoc, getDoc, doc, updateDoc, increment } from 'firebase/firestore';

import ButtonComponent from '../../button/Button';
import SubmissionSuccessful from '../submission-successful/SubmissionSuccessful';

function AddVenue({ size, show, handleClose}) {
    
    const [index, setIndex] = useState(0);
    const [fade, setFade] = useState("in");
    const [submitSuccessModal, setSubmitSuccessModal] = useState(false);

    const stateOptions = [
        { label: "Select a state", value: "" },
        { label: "Alabama", value: "AL" },
        { label: "Alaska", value: "AK" },
        { label: "Arizona", value: "AZ" },
        { label: "Arkansas", value: "AR" },
        { label: "California", value: "CA" },
        { label: "Colorado", value: "CO" },
        { label: "Connecticut", value: "CT" },
        { label: "Delaware", value: "DE" },
        { label: "Florida", value: "FL" },
        { label: "Georgia", value: "GA" },
        { label: "Hawaii", value: "HI" },
        { label: "Idaho", value: "ID" },
        { label: "Illinois", value: "IL" },
        { label: "Indiana", value: "IN" },
        { label: "Iowa", value: "IA" },
        { label: "Kansas", value: "KS" },
        { label: "Kentucky", value: "KY" },
        { label: "Louisiana", value: "LA" },
        { label: "Maine", value: "ME" },
        { label: "Maryland", value: "MD" },
        { label: "Massachusetts", value: "MA" },
        { label: "Michigan", value: "MI" },
        { label: "Minnesota", value: "MN" },
        { label: "Mississippi", value: "MS" },
        { label: "Missouri", value: "MO" },
        { label: "Montana", value: "MT" },
        { label: "Nebraska", value: "NE" },
        { label: "Nevada", value: "NV" },
        { label: "New Hampshire", value: "NH" },
        { label: "New Jersey", value: "NJ" },
        { label: "New Mexico", value: "NM" },
        { label: "New York", value: "NY" },
        { label: "North Carolina", value: "NC" },
        { label: "North Dakota", value: "ND" },
        { label: "Ohio", value: "OH" },
        { label: "Oklahoma", value: "OK" },
        { label: "Oregon", value: "OR" },
        { label: "Pennsylvania", value: "PA" },
        { label: "Rhode Island", value: "RI" },
        { label: "South Carolina", value: "SC" },
        { label: "South Dakota", value: "SD" },
        { label: "Tennessee", value: "TN" },
        { label: "Texas", value: "TX" },
        { label: "Utah", value: "UT" },
        { label: "Vermont", value: "VT" },
        { label: "Virginia", value: "VA" },
        { label: "Washington", value: "WA" },
        { label: "West Virginia", value: "WV" },
        { label: "Wisconsin", value: "WI" },
        { label: "Wyoming", value: "WY" }
    ];

    const venueTypeOptions = [
        "Stadium",
        "Sports Bar",
        "Team Bar"
    ];
    
    const teamOptions = [
        { label: "Select a team", value: "" },
        { label: "Arizona Cardinals", value: "Arizona Cardinals" },
        { label: "Atlanta Falcons", value: "Atlanta Falcons" },
        { label: "Baltimore Ravens", value: "Baltimore Ravens" },
        { label: "Buffalo Bills", value: "Buffalo Bills" },
        { label: "Carolina Panthers", value: "Carolina Panthers" },
        { label: "Chicago Bears", value: "Chicago Bears" },
        { label: "Cincinnati Bengals", value: "Cincinnati Bengals" },
        { label: "Cleveland Browns", value: "Cleveland Browns" },
        { label: "Dallas Cowboys", value: "Dallas Cowboys" },
        { label: "Denver Broncos", value: "Denver Broncos" },
        { label: "Detroit Lions", value: "Detroit Lions" },
        { label: "Green Bay Packers", value: "Green Bay Packers" },
        { label: "Houston Texans", value: "Houston Texans" },
        { label: "Indianapolis Colts", value: "Indianapolis Colts" },
        { label: "Jacksonville Jaguars", value: "Jacksonville Jaguars" },
        { label: "Kansas City Chiefs", value: "Kansas City Chiefs" },
        { label: "Las Vegas Raiders", value: "Las Vegas Raiders" },
        { label: "Los Angeles Chargers", value: "Los Angeles Chargers" },
        { label: "Los Angeles Rams", value: "Los Angeles Rams" },
        { label: "Miami Dolphins", value: "Miami Dolphins" },
        { label: "Minnesota Vikings", value: "Minnesota Vikings" },
        { label: "New England Patriots", value: "New England Patriots" },
        { label: "New Orleans Saints", value: "New Orleans Saints" },
        { label: "New York Giants", value: "New York Giants" },
        { label: "New York Jets", value: "New York Jets" },
        { label: "Philadelphia Eagles", value: "Philadelphia Eagles" },
        { label: "Pittsburgh Steelers", value: "Pittsburgh Steelers" },
        { label: "San Francisco 49ers", value: "San Francisco 49ers" },
        { label: "Seattle Seahawks", value: "Seattle Seahawks" },
        { label: "Tampa Bay Buccaneers", value: "Tampa Bay Buccaneers" },
        { label: "Tennessee Titans", value: "Tennessee Titans" },
        { label: "Washington Football Team", value: "Washington Football Team" }
    ];
    const teamToTagMapping = {
        "Arizona Cardinals": "ARI",
        "Atlanta Falcons": "ATL",
        "Baltimore Ravens": "BAL",
        "Buffalo Bills": "BUF",
        "Carolina Panthers": "CAR",
        "Chicago Bears": "CHI",
        "Cincinnati Bengals": "CIN",
        "Cleveland Browns": "CLE",
        "Dallas Cowboys": "DAL",
        "Denver Broncos": "DEN",
        "Detroit Lions": "DET",
        "Green Bay Packers": "GB",
        "Houston Texans": "HOU",
        "Indianapolis Colts": "IND",
        "Jacksonville Jaguars": "JAX",
        "Kansas City Chiefs": "KC",
        "Las Vegas Raiders": "LV",
        "Los Angeles Chargers": "LAC",
        "Los Angeles Rams": "LA",
        "Miami Dolphins": "MIA",
        "Minnesota Vikings": "MIN",
        "New England Patriots": "NE",
        "New Orleans Saints": "NO",
        "New York Giants": "NYG",
        "New York Jets": "NYJ",
        "Philadelphia Eagles": "PHI",
        "Pittsburgh Steelers": "PIT",
        "San Francisco 49ers": "SF",
        "Seattle Seahawks": "SEA",
        "Tampa Bay Buccaneers": "TB",
        "Tennessee Titans": "TEN",
        "Washington Football Team": "WFT"
    };
    const getSubmissionCount = async () => {
        const docRef = doc(db, 'venues', 'venueSubmissions');
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            return docSnap.data().count;
        } else {
            console.error("No such document!");
            return null;
        }
    };

    const incrementSubmissionCount = async () => {
        const docRef = doc(db, 'venues', 'venueSubmissions');
        await updateDoc(docRef, {
            count: increment(1)
        });
    };
    const formik = useFormik({
        initialValues: {
            addressLineOne: '',
            addressLineTwo: '',
            city: '',
            state: '',
            tag: '',
            team: '',
            venue: '',
            venueType: 'Team Bar',
            zipCode: '',
            latitude: '',
            longitude: '',
        },
        validationSchema: Yup.object({
            team: Yup.string(),
            venue: Yup.string().required('Venue Name is required'),
            addressLineOne: Yup.string().required('Address line 1 is required'),
            addressLineTwo: Yup.string(),
            city: Yup.string().required('City is required'),
            state: Yup.string()
                .required('State is required')
                .notOneOf([""], "Please select a state"),
            zipCode: Yup.string()
            .required('Zip Code required')
            .matches(/^(\d{5}|\d{5}-\d{4})$/, 'Invalid ZIP code format')
        }),
        onSubmit: async (values, { resetForm }) => {
            const currentCount = await getSubmissionCount();
            const MAX_SUBMISSIONS = 50;

            if (currentCount >= MAX_SUBMISSIONS) {
                alert("You've reached the maximum number of submissions!");
                return;
            }
            const tagValue = teamToTagMapping[values.team];
            const docData = {
                ...values,
                ...(tagValue ? { tag: tagValue } : {})
                // location: geoLocation
            };

            try {
                await incrementSubmissionCount();
                await addDoc(collection(db, "venues"), docData);
                handleClose();
                resetForm();
                setSubmitSuccessModal(true);
            } catch (error) {
                console.error("Error adding document: ", error);
            }
        },
    });
    const getIconForRadio = (type) => {
        switch (type) {
            case "Sports Bar":
                return faBeer;
            case "Team Bar":
                return faPeopleGroup;
            case "Stadium":
                return faFootball;
            default:
                return null;
        }
    }
    useEffect(() => {
        const interval = setInterval(() => {
            setFade("out"); // Start by fading out the current text

            setTimeout(() => {
                setIndex((prevIndex) => (prevIndex + 1) % venueTypeOptions.length);
                setFade("in"); // Then fade in the next text
            }, 1000); // Wait for the fade-out to complete before switching text
        }, 3000); // Change every 4 seconds (2 seconds visible, 2 seconds transition)

        return () => clearInterval(interval);
    }, []);

    const heading = "Add a";

    return (
        <>

            

            <Modal className='add-venue' size={size} show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <div className="main-img"></div>
                    <div className='title'>
                        <h2 className='heading'>
                            {heading} <span className={`dynamic-text fade-${fade}`}>{venueTypeOptions[index]}</span>
                        </h2>
                    </div>
                    
                </Modal.Header>
                <Modal.Body>
                    
                    <form className='form' onSubmit={formik.handleSubmit}>
                        <Container>
                            <div className='tiles'>
                            {venueTypeOptions.map((type) => (
                                <div className='input-container'>
                                    <input
                                        className='radio-button'
                                        type="radio"
                                        name="venueType"
                                        value={type}
                                        checked={formik.values.venueType === type}
                                        onChange={(e) => {
                                            formik.handleChange(e);
                                        }}
                                        id={`radio-${type}`}
                                    />
                                    <div className='radio-tile'>
                                        <div  className='icon'>
                                        <FontAwesomeIcon icon={getIconForRadio(type)} />
                                        </div>
                                        <label className='radio-tile-label' key={type}>{type}</label>
                                    </div>
                                </div>
                            ))}
                            </div>
                            
                        
                            <Row>
                                <Col>
                                {formik.values.venueType !== "Sports Bar" && (
                                    <div className='input-wrap'>
                                        <Form.Select
                                            name="team"
                                            value={formik.values.team}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            className={formik.touched.team && formik.errors.team ? 'input-error' : ''}
                                        >
                                            {teamOptions.map((option) => (
                                                <option key={option.value} value={option.value}>
                                                    {option.label}
                                                </option>
                                            ))}
                                        </Form.Select>

                                    </div>
                                )}
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <div className='input-wrap'>
                                        <FloatingLabel
                                            controlId="floatingInput"
                                            label="Venue Name"
                                        >
                                            <Form.Control
                                                name="venue"
                                                value={formik.values.venue}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                placeholder="Venue Name"
                                                className={formik.touched.venue && formik.errors.venue ? 'input-error' : '' }
                                            />
                                        </FloatingLabel>
                                    </div>
                                    {formik.touched.venue && formik.errors.venue ? (
                                        <p className='error-message'>{formik.errors.venue}</p>
                                    ) : null}
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <div className='input-wrap'>
                                        <FloatingLabel
                                            controlId="floatingInput"
                                            label="Address Line 1"
                                        >
                                            <Form.Control
                                                name="addressLineOne"
                                                value={formik.values.addressLineOne}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                placeholder="Address Line 1"
                                                className={formik.touched.addressLineOne && formik.errors.addressLineOne ? 'input-error' : '' }
                                            />
                                        </FloatingLabel>
                                    </div>
                                    {formik.touched.addressLineOne && formik.errors.addressLineOne ? (
                                        <p className='error-message'>{formik.errors.addressLineOne}</p>
                                    ) : null}
                                </Col>
                            </Row>
                        
                            <Row>
                                <Col>
                                    <div className='input-wrap'>
                                        <FloatingLabel
                                            controlId="floatingInput"
                                            label="Address Line 2"
                                        >
                                            <Form.Control
                                                name="addressLineTwo"
                                                value={formik.values.addressLineTwo}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                placeholder="Address Line 2"
                                            />
                                        </FloatingLabel>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <div className='input-wrap'>
                                        <FloatingLabel
                                            controlId="floatingInput"
                                            label="City"
                                        >
                                            <Form.Control
                                                name="city"
                                                value={formik.values.city}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                placeholder="City"
                                                className={formik.touched.city && formik.errors.city ? 'input-error' : ''}
                                            />
                                        </FloatingLabel>
                                    </div>
                                    {formik.touched.city && formik.errors.city ? (
                                        <p className='error-message'>{formik.errors.city}</p>
                                    ) : null}
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <div className='input-wrap'>
                                        <FloatingLabel
                                            controlId="floatingInput"
                                            label="Zip Code"
                                        >
                                            <Form.Control
                                                name="zipCode"
                                                value={formik.values.zipCode}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                placeholder="Zip Code"
                                                className={formik.touched.zipCode && formik.errors.zipCode ? 'input-error' : ''}
                                            />
                                            </FloatingLabel>
                                    </div>
                                    {formik.touched.zipCode && formik.errors.zipCode ? (
                                        <p className='error-message'>{formik.errors.zipCode}</p>
                                    ) : null}
                                </Col>
                                <Col>
                                    <div className='input-wrap'>
                                        <Form.Select
                                            name="state"
                                            value={formik.values.state}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            className={formik.touched.state && formik.errors.state ? 'input-error' : ''}
                                        >
                                            
                                            {stateOptions.map((option) => (
                                                <option key={option.value} value={option.value}>
                                                    {option.label}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </div>
                                    {formik.touched.state && formik.errors.state ? (
                                        <p className='error-message'>{formik.errors.state}</p>
                                    ) : null}
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <div className="submit-wrap">
                                        <ButtonComponent disabled={!formik.isValid} buttonType="Primary" buttonStyle="Standard" buttonText="Add a Venue" type="submit"/>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </form>
                </Modal.Body>
            </Modal>
            
            <SubmissionSuccessful 
                showSubmitSuccess={submitSuccessModal}
                onClose={() => setSubmitSuccessModal(false)}
            />
        </>
    );
}

export default AddVenue;